import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import { useSelector } from "react-redux";
import {
  DocumentDownload,
  Edit,
  Edit2,
  ProfileAdd,
  Trash,
} from "iconsax-react";
import { Link } from "react-router-dom";

function List(props) {
  const [stockList, setstockList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [plantLocation, setPlantLocation] = useState("");
  const [selectedStatus, setSelectedSatus] = useState("");
  const [itemName, setItemName] = useState("");
  const [isFind, setIsFind] = useState(false);
  const [isreset, setIsreset] = useState(false);
  const [status] = useState([
    {
      id: "High",
      name: "High",
    },
    {
      id: "Medium",
      name: "Medium",
    },
    {
      id: "Low",
      name: "Low",
    },
  ]);
  const columns = [
    {
      name: "Item Name",
      selector: (row) => row.product_name,
    },
    {
      name: "Item Code",
      selector: (row) => row.product_code,
    },
    {
      name: "Available QTY",
      selector: (row) => parseFloat(Number(row.available_qty || 0).toFixed(4)),
    },
    {
      name: "Used QTY",
      selector: (row) => parseFloat(Number(row.debit_qty || 0).toFixed(4)),
    },
    {
      name: "Total QTY",
      selector: (row) => parseFloat(Number(row.credit_qty || 0).toFixed(4)),
    },
  ];

  useEffect(() => {
    getStock();
  }, [page, filterText]);

  useEffect(() => {
    getPlantList();
  }, []);

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch((err) => {
        setPlantList([]);
      });
  };
  const getStock = () => {
    utils
      .callAPI(
        "get",
        `stock/list?plant_id=${plantLocation}&product=${itemName}&status=${selectedStatus}&page=${page}&per_page=${countPerPage}`,
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setstockList(res);
          setIsFind(false);
          setIsreset(false);
        } else {
          setstockList([]);
        }
      })
      .catch((err) => {
        setstockList([]);
      });
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.stock_alert === "High",
      style: {
        backgroundColor: "#f8d7da",
        color: "black",
      },
    },
    {
      when: (row) => row.stock_alert === "Medium",
      style: {
        backgroundColor: "#ffe180",
        color: "black",
      },
    },
    {
      when: (row) => row.stock_alert === "Low",
      style: {
        backgroundColor: "#a5d9b1",
        color: "black",
      },
    },
    {
      when: (row) => row.stock_alert === "No Alert",
      style: {
        backgroundColor: "white",
        color: "black",
      },
    },
  ];

  useEffect(() => {
    if (isFind) {
      getStock();
    }
    if (isreset) {
      getStock();
    }
  }, [isFind, isreset]);

  const handleFind = () => {
    setIsFind(true);
    setPage(1);
  };

  const handleReset = () => {
    setItemName("");
    setPlantLocation("");
    setSelectedSatus("");
    setIsreset(true);
  };

  const handleDownload = () => {
    const params = new URLSearchParams({
      plant_id: plantLocation || "",
      product: itemName || "",
      status: selectedStatus || "",
      page: 0,
      per_page: 0,
    }).toString();

    utils
      .callAPI("get", `stock/list?${params}`)
      .then((res) => {
        if (res && Array.isArray(res.result) && res.result.length > 0) {
          // ✅ CSV header as per your fields
          const csvHeader = `Sr.No.,Item Code,Item Name,Plant Location,Status,Available Qty,Used Qty,Total Qty`;

          // ✅ Map through all rows
          const csvRows = res.result.map((item, index) => {
            const alertStatus =
              item.stock_alert === "No Alert" ? "" : item.stock_alert;

            return [
              index + 1,
              `"${item.product_code || ""}"`,
              `"${item.product_name || ""}"`,
              `"${item.plant_name || ""}"`,
              `"${alertStatus}"`,
              `"${item.available_qty || 0}"`,
              `"${item.debit_qty || 0}"`,
              `"${item.credit_qty || 0}"`,
            ].join(",");
          });

          // ✅ Join everything into a single CSV string
          const csvContent = [csvHeader, ...csvRows].join("\n");

          // ✅ Create and trigger download
          const blob = new Blob([csvContent], {
            type: "text/csv;charset=utf-8;",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "Stock_List.csv";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((err) => {
        console.error("Download error:", err);
      });
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.CardHeader>
          <div className="floating-btns-holder-artisan">
            {/* {utils.hasPermission(
                      primaryMenuRes,
                      "Employee",
                      "employee.download"
                    ) && ( */}
            <a
              href
              className={`${
                stockList.result?.length == 0 ? "disabled" : ""
              } btn btn-primary btn-circle me-2`}
              variant="primary"
              onClick={() => handleDownload()}
            >
              <DocumentDownload />
            </a>
            {/* )} */}
          </div>
        </RB.CardHeader>
        <RB.Card.Body>
          <RB.Row className="mb-2 g-2">
            <RB.Col className="col-md col-12">
              <RB.FloatingLabel
                controlId="plantLocation"
                label="Item Name or Item Code"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  placeholder="Item Name or Product"
                  value={itemName}
                  onChange={(e) => setItemName(e.target.value)}
                />
              </RB.FloatingLabel>
            </RB.Col>

            <RB.Col className="col-md col-12">
              <RB.FloatingLabel
                controlId="plantLocation"
                label="Plant Location"
                className="floating-label-fancy"
              >
                <RB.Form.Select
                  value={plantLocation}
                  onChange={(e) => setPlantLocation(e.target.value)}
                  required
                >
                  <option value="">Select Plant Location</option>
                  {plantList.map((plant) => (
                    <option key={plant.id} value={plant.id}>
                      {plant.plant_name}
                    </option>
                  ))}
                  {/* Add more options as necessary */}
                </RB.Form.Select>
              </RB.FloatingLabel>
            </RB.Col>

            <RB.Col className="col-md col-12">
              <RB.FloatingLabel
                controlId="plantLocation"
                label="Select Status"
                className="floating-label-fancy"
              >
                <RB.Form.Select
                  value={selectedStatus}
                  onChange={(e) => setSelectedSatus(e.target.value)}
                  required
                >
                  <option value="">Select Status</option>
                  {status.map((st) => (
                    <option key={st.id} value={st.id}>
                      {st.name}
                    </option>
                  ))}
                </RB.Form.Select>
              </RB.FloatingLabel>
            </RB.Col>
            <RB.Col className="col-sm">
              <RB.Button
                className=" btn-md ms-4 mt-3 me-2"
                variant="primary"
                onClick={handleFind}
                disabled={!itemName && !plantLocation && !selectedStatus}
              >
                Find
              </RB.Button>
              <Link
                className="ms-2 mt-3 btn-underline"
                // variant="secondary"
                onClick={handleReset}
              >
                Reset
              </Link>
            </RB.Col>
          </RB.Row>
          <DataTable
            columns={columns}
            data={stockList.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={stockList.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            paginationComponent={() => (
              <CustomPagination
                currentPage={page}
                totalRows={stockList.total}
                rowsPerPage={countPerPage}
                onPageChange={handlePageChange}
              />
            )}
            // striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem",
                  fontWeight: "bold",
                },
              },
            }}
            conditionalRowStyles={conditionalRowStyles}
          />
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
